import React, { Component } from 'react';
import '../css/youtube_controls.scss';

export default class YouTubeControls extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPlaying: false,
      currentTime: 0,
      duration: 0,
      // FIX 20260731-volumekeep 初期値は会員単位の保存値(未設定なら音量50・ミュート)
      volume: (typeof gon !== 'undefined' && gon.video_volume != null) ? gon.video_volume : 100,
      isMuted: (typeof gon !== 'undefined' && gon.video_muted != null) ? !!gon.video_muted : props.opts.playerVars.mute === 1,
      isFullscreen: false,
      showVolumeSlider: false,
      buffered: 0,
      isHovering: false,
      showControls: true,
      showSettingsMenu: false,
      playbackRate: 1,
    };
    // FIX 20260731-volumekeep 音量・ミュートをサーバーへ保存(連打しても最後の1回だけ)
    this._tmSaveVolume = (volume, muted) => {
      clearTimeout(this._tmVolTimer);
      this._tmVolTimer = setTimeout(() => {
        try {
          const t = document.querySelector('meta[name="csrf-token"]');
          fetch('/users/save_video_volume', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': t ? t.content : '' },
            credentials: 'same-origin',
            body: JSON.stringify({ volume: Math.round(volume), muted: muted })
          }).catch(() => {});
        } catch (e) {}
      }, 600);
    };
    // FIX 20260731-volumekeep 保存した音量・ミュートをYouTube本体へ適用する。
    // 数値を入れるだけではYouTube側がミュートのままなため、unMute/mute を必ず呼ぶ
    this._tmApplyVolume = () => {
      try {
        const p = this.props.player || (this.props.getPlayer && this.props.getPlayer());
        if (!p || typeof p.setVolume !== 'function') return false;
        p.setVolume(this.state.volume);
        if (this.state.isMuted) { if (p.mute) p.mute(); }
        else { if (p.unMute) p.unMute(); }
        return true;
      } catch (e) { return false; }
    };
    this.progressRef = React.createRef();
    this.hideControlsTimeout = null;
    this.bodyScrollTop = 0;
  }

  componentDidMount() {
    // FIX 20260731-volumekeep 読み込みのタイミングが端末で差なので複数回試す
    [300, 1000, 2000, 3500, 5000].forEach((ms) => setTimeout(() => this._tmApplyVolume(), ms));
    this.updateInterval = setInterval(this.updateProgress, 100);
    document.addEventListener('fullscreenchange', this.handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange);
    document.addEventListener('click', this.handleClickOutside);
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    clearInterval(this.updateInterval);
    clearTimeout(this.hideControlsTimeout);
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
    document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange);
    document.removeEventListener('click', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleKeyDown);
    this.clearFallbackFullscreen();
  }

  getFullscreenElement = () => (
    document.fullscreenElement ||
    document.webkitFullscreenElement ||
    document.mozFullScreenElement ||
    document.msFullscreenElement
  );

  isIOSDevice = () => {
    const ua = navigator.userAgent || '';
    const platform = navigator.platform || '';
    return /iPad|iPhone|iPod/.test(ua) || (platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  };

  updateProgress = () => {
    const { player } = this.props;

    const { playbackRate } = this.state;
    if (player && player.getCurrentTime && player.getDuration) {
      const currentTime = player.getCurrentTime() || 0;
      const duration = player.getDuration() || 0;
      const playerState = player.getPlayerState();
      
      this.setState({
        currentTime,
        duration,
        isPlaying: playerState === 1, // 1 = playing
        playbackRate: playbackRate,
      });
    }
  };

  handleClickOutside = (e) => {
    if (this.settingsRef && !this.settingsRef.contains(e.target)) {
      this.setState({ showSettingsMenu: false });
    }
  };

  getFullscreenTarget = () => {
    const { player, containerRef } = this.props;

    return containerRef?.current || containerRef || document.getElementById('iframe-show-video') || (player?.getIframe ? player.getIframe() : null);
  };

  isFallbackFullscreenActive = () => {
    const element = this.getFullscreenTarget();
    return !!element?.classList?.contains('ios-fullscreen');
  };

  enableFallbackFullscreen = () => {
    const element = this.getFullscreenTarget();
    if (!element?.classList) return false;

    this.bodyScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    element.classList.add('ios-fullscreen');
    document.body.classList.add('ios-fullscreen-active');
    document.body.style.top = `-${this.bodyScrollTop}px`;
    return true;
  };

  clearFallbackFullscreen = () => {
    const element = this.getFullscreenTarget();
    if (element?.classList) {
      element.classList.remove('ios-fullscreen');
    }
    document.body.classList.remove('ios-fullscreen-active');
    document.body.style.top = '';
  };

  disableFallbackFullscreen = () => {
    const scrollTop = this.bodyScrollTop;
    this.clearFallbackFullscreen();
    window.scrollTo(0, scrollTop || 0);
  };

  // Change playback rate
  handlePlaybackRateChange = (rate) => {
    const { player, handlePlaybackRateChange } = this.props;
    if (!player) return;

    handlePlaybackRateChange(rate);
    this.setState({ 
      playbackRate: rate,
      showSettingsMenu: false 
    });
  };

  // Toggle settings menu
  toggleSettingsMenu = () => {
    this.setState(prevState => ({ 
      showSettingsMenu: !prevState.showSettingsMenu,
      showVolumeSlider: false // Close volume slider when opening settings
    }));
  };

  handleFullscreenChange = () => {
    const isFullscreen = !!this.getFullscreenElement() || this.isFallbackFullscreenActive();

    this.setState({
      isFullscreen: isFullscreen,
    }, () => {
      // Call onChangeFullscreen when fullscreen state changes (e.g., ESC key pressed)
      this.onChangeFullscreen();
    });
  };

  onChangeFullscreen = () => {
    const { isFullscreen } = this.state;
    this.setState({
      showControls: true,
      showVolumeSlider: false,
      showSettingsMenu: false,
    });
    this.props.onChangeFullscreen(isFullscreen);
  };

  // Play/Pause
  togglePlay = () => {
    const { player, onBeforePlay } = this.props;
    if (!player) return;

    const doPlay = () => {
      if (this.state.isPlaying) {
        player.pauseVideo();
      } else {
        player.playVideo();
      }
      this.setState({ isPlaying: !this.state.isPlaying });
    };

    if (onBeforePlay) {
      onBeforePlay(doPlay);
    } else {
      doPlay();
    }
  };

  // Seek
  handleProgressClick = (e) => {
    const { player, onBeforePlay } = this.props;
    if (!player || !this.progressRef.current) return;

    const rect = this.progressRef.current.getBoundingClientRect();
    const percent = (e.clientX - rect.left) / rect.width;
    const seekTime = percent * this.state.duration;

    const doSeek = () => {
      player.seekTo(seekTime, true);
      this.setState({ currentTime: seekTime });
    };

    if (onBeforePlay) {
      onBeforePlay(doSeek);
    } else {
      doSeek();
    }
  };

  handleProgressDrag = (e) => {
    if (e.buttons !== 1) return; // Only on left mouse button
    this.handleProgressClick(e);
  };

  // Volume
  toggleMute = () => {
    const { player } = this.props;
    if (!player) return;

    if (this.state.isMuted) {
      player.unMute();
      player.setVolume(this.state.volume);
    } else {
      player.mute();
    }
    this.setState({ isMuted: !this.state.isMuted });
    this._tmSaveVolume(this.state.volume, !this.state.isMuted); // FIX 20260731-volumekeep 
  };

  handleVolumeChange = (e) => {
    const { player } = this.props;
    if (!player) return;

    const volume = parseInt(e.target.value, 10);
    player.setVolume(volume);
    this.setState({ volume, isMuted: volume === 0 });
    this._tmSaveVolume(volume > 0 ? volume : this.state.volume, volume === 0); // FIX 20260731-volumekeep 
    if (volume > 0) {
      player.unMute();
    } else {
      player.mute();
    }
  };

  // Fullscreen
  toggleFullscreen = () => {
    const element = this.getFullscreenTarget();
    
    if (!element) return;

    const isFallbackFullscreen = this.isFallbackFullscreenActive();
    const requestFullscreen =
      element.requestFullscreen ||
      element.webkitRequestFullscreen ||
      element.mozRequestFullScreen ||
      element.msRequestFullscreen;
    const exitFullscreen =
      document.exitFullscreen ||
      document.webkitExitFullscreen ||
      document.mozCancelFullScreen ||
      document.msExitFullscreen;

    if (!this.getFullscreenElement() && !isFallbackFullscreen) {
      if ((this.props.mobile && this.isIOSDevice()) || typeof requestFullscreen !== 'function') {
        if (!this.enableFallbackFullscreen()) return;
        this.setState({ isFullscreen: true }, () => {
          this.onChangeFullscreen();
        });
        return;
      }

      if (typeof requestFullscreen !== 'function') {
        return;
      }

      requestFullscreen.call(element);
      this.setState({ isFullscreen: true }, () => {
        this.onChangeFullscreen();
      });
    } else {
      if (isFallbackFullscreen) {
        this.disableFallbackFullscreen();
        this.setState({ isFullscreen: false }, () => {
          this.onChangeFullscreen();
        });
        return;
      }

      if (typeof exitFullscreen !== 'function') {
        return;
      }

      exitFullscreen.call(document);
      this.setState({ isFullscreen: false }, () => {
        this.onChangeFullscreen();
      });
    }
  };

  // Skip forward/backward
  skip = (seconds) => {
    const { player, onBeforePlay } = this.props;
    if (!player) return;

    const doSkip = () => {
      const newTime = Math.max(0, Math.min(this.state.currentTime + seconds, this.state.duration));
      player.seekTo(newTime, true);
    };

    if (onBeforePlay) {
      onBeforePlay(doSkip);
    } else {
      doSkip();
    }
  };

  // Format time
  formatTime = (seconds) => {
    if (isNaN(seconds) || seconds === 0) return '0:00';
    
    const hours = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
    
    if (hours > 0) {
      return `${hours}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  // Auto-hide controls
  handleMouseMove = () => {
    this.setState({ showControls: true });
    clearTimeout(this.hideControlsTimeout);
    // comment out because it's not working on mobile
    // if (this.state.isPlaying) {
    //   this.hideControlsTimeout = setTimeout(() => {
    //     this.setState({ showControls: false });
    //   }, 3000);
    // }
  };

  handleMouseEnter = () => {
    this.setState({ isHovering: true, showControls: true });
    clearTimeout(this.hideControlsTimeout);
  };

  handleMouseLeave = () => {
    this.setState({ isHovering: false });
    // comment out because it's not working on mobile
    // if (this.state.isPlaying) {
    //   this.hideControlsTimeout = setTimeout(() => {
    //     this.setState({ showControls: false });
    //   }, 1000);
    // }
  };

  handleKeyDown = (e) => {
    // Ignore when typing in form fields (but allow from buttons so arrow keys still work after clicking controls)
    const target = e.target;
    const tag = target?.tagName;
    const isEditable = target?.isContentEditable;
    if (['INPUT', 'TEXTAREA', 'SELECT', 'OPTION'].includes(tag) || isEditable) return;

    if (e.key === 'ArrowRight') {
      e.preventDefault();
      this.skip(5);
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault();
      this.skip(-5);
    } else if (e.code === 'Space' || e.key === ' ') {
      e.preventDefault();
      this.togglePlay();
    } else if (e.key === 'Escape' && this.state.isFullscreen) {
      // Handle ESC key to exit fullscreen
      this.toggleFullscreen();
    }
  };

  render() {
    const { 
      isPlaying, currentTime, duration, volume, isMuted, 
      isFullscreen, showVolumeSlider, showControls 
    } = this.state;

    const { player } = this.props;
    // current youtube not support playback rates
    let playbackRates = [1]
    if (!!player) {
      const rates = player.getAvailablePlaybackRates()
      playbackRates = !!rates && rates.length > 1 ? rates : [1]
    }
    
    const progress = duration > 0 ? (currentTime / duration) * 100 : 0;

    return (
      <>
      <div 
        className={`youtube-controls-wrapper ${showControls ? 'visible' : 'hidden'} ${isFullscreen ? 'is-fullscreen' : ''}`}
        onMouseMove={this.handleMouseMove}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onTouchStart={this.handleMouseMove}
      >
        {/* Gradient overlay */}
        <div className="youtube-controls-gradient" />
        
        {/* Progress bar */}
        <div 
          className="youtube-progress-bar"
          ref={this.progressRef}
          onClick={this.handleProgressClick}
          onMouseMove={this.handleProgressDrag}
        >
          <div className="youtube-progress-buffered" style={{ width: '0%' }} />
          <div className="youtube-progress-played" style={{ width: `${progress}%` }}>
            <div className="youtube-progress-scrubber" />
          </div>
        </div>
        
        {/* Controls */}
        <div className="youtube-controls">
          {/* Left controls */}
          <div className="youtube-controls-left">
            {/* Play/Pause */}
            <button className="youtube-btn" onClick={this.togglePlay} title={isPlaying ? '一時停止' : '再生'}>
              {isPlaying ? (
                <svg viewBox="0 0 24 24" width="24" height="24">
                  <path fill="currentColor" d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
                </svg>
              ) : (
                <svg viewBox="0 0 24 24" width="24" height="24">
                  <path fill="currentColor" d="M8 5v14l11-7z"/>
                </svg>
              )}
            </button>
            
            {/* Skip backward 10s */}
            <button className="youtube-btn" onClick={() => this.skip(-5)} title="5秒戻る">
              <svg viewBox="0 0 24 24" width="24" height="24">
                <path fill="currentColor" d="M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"/>
                <text x="12" y="15" textAnchor="middle" fontSize="7" fill="currentColor">5</text>
              </svg>
            </button>
            
            {/* Skip forward 10s */}
            <button className="youtube-btn" onClick={() => this.skip(5)} title="5秒進む">
              <svg viewBox="0 0 24 24" width="24" height="24">
                <path fill="currentColor" d="M12 5V1l5 5-5 5V7c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6h2c0 4.42-3.58 8-8 8s-8-3.58-8-8 3.58-8 8-8z"/>
                <text x="12" y="15" textAnchor="middle" fontSize="7" fill="currentColor">5</text>
              </svg>
            </button>
            
            {/* Volume */}
            <div className="youtube-volume-container">
              <button
                className="youtube-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  this.toggleMute(); // FIX 20260801-volumeui
                }}
                title={isMuted ? 'ミュート解除' : 'ミュート'}
              >
                {isMuted || volume === 0 ? (
                  <svg viewBox="0 0 24 24" width="24" height="24">
                    <path fill="currentColor" d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>
                  </svg>
                ) : volume < 50 ? (
                  <svg viewBox="0 0 24 24" width="24" height="24">
                    <path fill="currentColor" d="M18.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z"/>
                  </svg>
                ) : (
                  <svg viewBox="0 0 24 24" width="24" height="24">
                    <path fill="currentColor" d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
                  </svg>
                )}
              </button>

              <div className="youtube-volume-slider visible">
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={isMuted ? 0 : volume}
                  onChange={this.handleVolumeChange}
                  className="youtube-volume-input"
                />
              </div>
            </div>
            
            {/* Time display */}
            <div className="youtube-time">
              <span>{this.formatTime(currentTime)}</span>
              <span className="youtube-time-separator">/</span>
              <span>{this.formatTime(duration)}</span>
            </div>
          </div>
          
          <div className="youtube-controls-right d-flex">
            {/* Settings */}
            <div 
              className="youtube-settings-container"
              ref={(ref) => (this.settingsRef = ref)}
            >
              <button 
                className="youtube-btn" 
                onClick={(e) => {
                  e.stopPropagation();
                  this.toggleSettingsMenu();
                }}
                title="設定"
              >
                <svg viewBox="0 0 24 24" width="24" height="24">
                  <path fill="currentColor" d="M19.14 12.94c.04-.31.06-.63.06-.94 0-.31-.02-.63-.06-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.04.31-.06.63-.06.94s.02.63.06.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"/>
                </svg>
              </button>
              
              {/* Settings Menu */}
              {this.state.showSettingsMenu && (
                <div className="youtube-settings-menu">
                  <div className="youtube-settings-header">
                    <span>再生速度</span>
                  </div>
                  <div className="youtube-settings-options">
                    {playbackRates.map((rate) => (
                      <button
                        key={rate}
                        className={`youtube-settings-option ${this.state.playbackRate === rate ? 'active' : ''}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          this.handlePlaybackRateChange(rate);
                        }}
                      >
                        {rate === 1 ? '標準' : `${rate}x`}
                        {this.state.playbackRate === rate && (
                          <svg viewBox="0 0 24 24" width="16" height="16" className="check-icon">
                            <path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                          </svg>
                        )}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
            {/* Fullscreen */}
            <button className="youtube-btn"
                    onClick={(e) => {
                        e.stopPropagation();
                        this.toggleFullscreen(e);
                    }}
                    title={isFullscreen ? '全画面終了' : '全画面'}>
              {isFullscreen ? (
                <svg viewBox="0 0 24 24" width="24" height="24">
                  <path fill="currentColor" d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"/>
                </svg>
              ) : (
                <svg viewBox="0 0 24 24" width="24" height="24">
                  <path fill="currentColor" d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/>
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>
      {/* Fullscreen close button - always visible when fullscreen, even when controls are hidden */}
      {this.state.isFullscreen && (
        <button 
          className="ios-fullscreen-close"
          onClick={this.toggleFullscreen}
          type="button"
        >
          ✕
        </button>
      )}
      </>
    );
  }
}
